import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from "@material-ui/core/Paper";
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
// import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
// import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Avatar from "@material-ui/core/Avatar";
import MDTusersService from "../../services/MDTusersService";
import { deepOrange, deepPurple, blue, indigo, cyan } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    textAlign: "center",
    height: 30,
  },
  img: {
    height: 255,
    display: "block",
    maxWidth: 400,
    overflow: "hidden",
    width: "100%",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  blue: {
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: blue[500],
  },
  indigo: {
    color: theme.palette.getContrastText(indigo[500]),
    backgroundColor: indigo[500],
  },
  cyan: {
    color: theme.palette.getContrastText(cyan[500]),
    backgroundColor: cyan[500],
  },
}));

function MDTUsers() {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [mdtUsersdata, setMdtUsersdata] = useState([]);
  // const maxSteps = mdtUsersdata.length;

  const randomColor = (num) => {
    let color;
    switch (num) {
      case 1:
        color = classes.orange;
        break;

      case 2:
        color = classes.blue;
        break;

      case 3:
        color = classes.purple;
        break;
      case 4:
        color = classes.indigo;
        break;
      case 5:
        color = classes.cyan;
        break;

      default:
        color = classes.blue;
    }
    return color;
  };

  // const handleNext = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const getMDTUsersData = async () => {
    const data = await MDTusersService.getMDTUsers();
    if (data && data.knowledge) {
      const newKnowledge = [...data.knowledge, ...data.knowledge, ...data.knowledge, ...data.knowledge, ...data.knowledge];
      data.knowledge = newKnowledge;
    }
    setMdtUsersdata(data);
  };

  useEffect(() => {
    getMDTUsersData();
  }, []);

  try {
    return (
      <div className={classes.root}>
        <div className="scrollable-container">
          {(mdtUsersdata &&
            Object.keys(mdtUsersdata)?.map((item, index) => (
              <div key={index}>
                <Paper square elevation={0} className={classes.header}>
                  <h6 className="typoheading">Top {item} creators</h6>
                </Paper>
                <hr className="horizontal-tag" />
                <div key={index} className="avatarsdiv">
                  {mdtUsersdata?.[item] ? (
                    mdtUsersdata?.[item]?.map((mdt, idx) => (
                      <div key={idx} className="map-card">
                        <Avatar alt="Remy Sharp" className={randomColor(idx)} style={{ fontSize: "14px", fontWeight: "600", fontFamily: "sans-serif" }}>
                          {mdt.profile?.firstname?.[0] + mdt.profile?.lastname?.[0]}
                        </Avatar>
                        <div className="map-card-name">
                          <span>{mdt.profile?.firstname} </span>
                          <span>{mdt.profile?.lastname}</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>No contributor</div>
                  )}
                </div>
                {/* <div key={index} style={{fontSize:'12px'}}>
               {mdtUsersdata[item].map((mdt, idx )=> (
                <div key={idx}>
                  <span >{mdt.profile.firstname} </span>
                  <span>{mdt.profile.lastname}</span>
                </div>
                 ))}
                 </div> */}
              </div>
            ))) || <div>No contributor</div>}
        </div>
        {/* <MobileStepper
        style={{width:'20rem', padding:'0px'}}
          steps={maxSteps}
          position="static"
          variant='none'
          activeStep={activeStep}
          nextButton={
            <Button style={{position:'absolute', right:'0', top:'4.8rem',fontFamily: 'sans-serif'}} size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
              
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button style={{position:'absolute', left:'0', top:'4.8rem',fontFamily: 'sans-serif'}} size="small" onClick={handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      
            </Button>
          }
        /> */}
      </div>
    );
  } catch (err) {
    debugger;
    console.error(err);
    return null;
  }
}

export default MDTUsers;
